export interface OffsetDurations {
  repair?: number;
  replace?: number;
}
